// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2l0An","col":"styles_col__3baxf","fulfillmentStatus":"styles_fulfillmentStatus__1pdFc","emailCol":"styles_emailCol__1n9uI"};